import { render } from "./LoadingDataError.vue?vue&type=template&id=aa61722a&scoped=true"
import script from "./LoadingDataError.vue?vue&type=script&lang=js"
export * from "./LoadingDataError.vue?vue&type=script&lang=js"

import "./LoadingDataError.vue?vue&type=style&index=0&id=aa61722a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aa61722a"

export default script